module.exports = "<app-navbar *ngIf=\"loggedIn$ | async\"></app-navbar>\n\n<simple-notifications [options]=\"options\"></simple-notifications>\n\n<div class=\"wrapper\">\n  <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main